import {
  Box,
  capitalize,
  Checkbox,
  Typography
} from '@mui/material';
import React, { FC } from 'react';
import { Control, Controller } from 'react-hook-form';

import { PartyFile, RequestPartyFiles } from '../types';

type RequestDocumentItemProps = {
  file: PartyFile,
  requestIndex: number,
  control: Control<RequestPartyFiles, object>
}

export const RequestDocumentItem: FC<RequestDocumentItemProps> = ({
  file,
  requestIndex,
  control
}) => (
  <Box style={{ display: "flex", alignItems: "center" }}>
    <Controller
      control={control}
      name={`files.${requestIndex}.checked`}
      render={({ field }) => (
        <Checkbox
          {...field}
        />
      )}
    />
    <Typography variant="caption" color="primary">{capitalize(file.filename)}</Typography>
  </Box>
);
